import { DELETE_UNEP_ISSUE } from "../../../../enums/Profile/profile";

export const deleteUnepIssueAction = () => {
    return {
        type: DELETE_UNEP_ISSUE,
    };
};
